import { Component, OnInit } from '@angular/core';
import {variableGlobal} from './../../global.enum';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit {


  constructor(
    private _dbService: NgxIndexedDBService,
  private _api: IntranetoldService,
    private _route: Router,
    private Location:Location,
    private route: ActivatedRoute
  ) {

   }
   general = variableGlobal;
   // Evitar undefined en plantillas/bindings mientras carga
   menuAll: any[] = [];
   currentURL = "";
   login:any = {
    "NOMBRE": ""
   };

  ngOnInit(): void {




    this.currentURL = this.Location.path();
    this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_menu_final).subscribe(
      menu => {
        const manux: any = menu;
        const datos = manux?.datos;
        if (Array.isArray(datos) && datos.length > 0) {
          this.menuAll = datos;
          
        } else {
          
          this.cargarMenuDesdeCrudo();
        }

      },
      err => {
        
        this.cargarMenuDesdeCrudo();
      }
    );

      // Login: tolerante a distintas formas guardadas y con fallback
      this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(
        item => {
          const itemx: any = item;
          // soporta {datos: {login: {...}}} y {datos: {...}}
          const candidate = itemx?.datos?.login ?? itemx?.datos;
          if (candidate && typeof candidate === 'object') {
            this.login = candidate;
            this.cargarUsuarioDesdeApi();
          } else {
            
            this.tryLoginFallback();
            this.cargarUsuarioDesdeApi();
          }
                

        },
        err => {
          
          this.tryLoginFallback();
          this.cargarUsuarioDesdeApi();
        }
      );



    this._route.routeReuseStrategy.shouldReuseRoute = () => false;


  }

  private cargarMenuDesdeCrudo() {
    this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_menu).subscribe(
      menuCrudo => {
        const raw: any = menuCrudo;
        const objeto = raw?.datos ?? raw?.objeto; // por compatibilidad
        const padres = objeto?.padres ?? [];
        const hijos = objeto?.hijos ?? [];
        if (padres.length === 0) {
          
          this.menuAll = [];
          return;
        }
        const menuTrabajado: any[] = [];
        padres.forEach((p: any) => {
          const hijoAgregado = hijos.filter((h: any) => p._id === h.PADRE);
          menuTrabajado.push({ ...p, HIJOS: hijoAgregado });
        });
        this.menuAll = menuTrabajado;
        
      },
      err => {
        
        this.menuAll = [];
      }
    );
  }

  abrirInformeVenta(): void {
    const url = environment.RUTA_API + '/Excel/DescargaExcel?nombre=InformeVentasExcel';
    window.open(url, '_blank');
  }

  cambiaURL()
  {
    //window.location.href = url;
    //this._route.navigate([url]);

    //window.location.reload();
    this.currentURL = this.Location.path();
    


  }

  // Fallback mínimo si no está el registro en IndexedDB
  private tryLoginFallback() {
    try {
      const perfilStr = localStorage.getItem('PERFILJSON');
      const rut = localStorage.getItem('RUT_LOGUEADO');
      const perfil = perfilStr ? JSON.parse(perfilStr) : null;
      const nombre = perfil?.USUARIO?.NOMBRE || perfil?.USUARIO?.NOMBRES || perfil?.USUARIO?.NOMBRE_COMPLETO;
      this.login = {
        ...this.login,
        NOMBRE: nombre || this.login?.NOMBRE || '',
        RUT: rut || this.login?.RUT || ''
      };
      if (!nombre && !rut) {
        
      }
  this.login.IMAGE_LITTLE = this.normalizeImage(this.login?.IMAGE_LITTLE);
  
    } catch (e) {
      
    }
  }

  // Cargar usuario desde API igual que el CRUD y unirlo con el login actual
  private async cargarUsuarioDesdeApi() {
    try {
      const rutActual = this.login?.RUT || localStorage.getItem('RUT_LOGUEADO');
      if (!rutActual) { return; }
      const res: any = await this._api.getAllLogin();
      if (res?.estado && Array.isArray(res.objeto)) {
        const usuario = res.objeto.find((u: any) => (u.RUT + '') === (rutActual + ''));
        if (usuario) {
          const merged = { ...this.login, ...usuario };
          merged.IMAGE_LITTLE = this.normalizeImage(merged.IMAGE_LITTLE);
          this.login = merged;
          
        } else {
          
        }
      }
    } catch (e) {
      
    }
  }

  // Asegura que el base64 tenga prefijo data URL si viene “crudo”
  private normalizeImage(img?: string): string | undefined {
    if (!img) return img;
    const lower = img.toLowerCase();
    if (lower.startsWith('data:image')) return img; // ya tiene prefijo
    // heurística simple: si es base64 sin prefijo
    const isBase64 = /^[a-z0-9+/=\r\n]+$/i.test(img) && img.length > 40;
    if (isBase64) {
      // asumimos PNG por defecto
      return `data:image/png;base64,${img}`;
    }
    return img;
  }

}
